<template>
    <div class="main">
        <el-dialog
            :title="openData.title"
            :visible.sync="openData.state"
            :close-on-click-modal="false"
            width="70%"
            class="dialog_container"
            @close="dialogVisibleClone"
        >
            <div class="dialog_content">
                <el-form
                    label-position="left"
                    label-width="180px"
                    ref="formData"
                    :model="formData"
                    :rules="formDataRules"
                >
                    <el-row>
                        <el-col :span="11">
                            <el-form-item label="姓名：" prop="personName">
                                <el-input
                                    :disabled="openData.title == '详情'"
                                    v-model.trim="formData.personName"
                                    style="width: 100%"
                                    placeholder="请输入"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="出生日期：" prop="birthday">
                                <el-date-picker
                                    disabled
                                    v-model="formData.birthday"
                                    type="date"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期"
                                >
                                </el-date-picker>
                                <!-- <el-input
                  :disabled="openData.title == '详情'"
                  v-model="formData.birthday"
                ></el-input> -->
                            </el-form-item>
                            <el-form-item label="性别：" prop="sex">
                                <el-select
                                    disabled
                                    v-model="formData.sex"
                                    placeholder="请选择"
                                >
                                    <el-option
                                        v-for="item in sexOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="户籍地址：" prop="originPlace">
                                <el-input
                                    :disabled="openData.title == '详情'"
                                    v-model.trim="formData.originPlace"
                                    :autosize="{ minRows: 2 }"
                                    type="textarea"
                                    placeholder="请输入地址"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="文化程度：" prop="education">
                                <el-select
                                    :disabled="openData.title == '详情'"
                                    v-model="formData.education"
                                    placeholder="请选择"
                                >
                                    <el-option
                                        v-for="item in educationList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item
                                label="婚姻状况："
                                prop="maritalStatus"
                            >
                                <el-select
                                    :disabled="openData.title == '详情'"
                                    v-model="formData.maritalStatus"
                                    placeholder="请选择"
                                >
                                    <el-option
                                        v-for="item in maritalList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item
                                label="图片："
                                prop="photo"
                                align="left"
                            >
                                <el-upload
                                    :disabled="openData.title == '详情'"
                                    :action="baseUrl"
                                    :show-file-list="false"
                                    :on-success="
                                        (file, fileList) => {
                                            handleAvatarSuccess(
                                                file,
                                                fileList,
                                                'add'
                                            )
                                        }
                                    "
                                    :before-upload="beforeAvatarUpload"
                                >
                                    <div>
                                        <div
                                            class="avatar"
                                            v-if="formData.photo != ''"
                                        >
                                            <img
                                                :src="
                                                    formData.photo ==
                                                    '../../assets/img/user.png'
                                                        ? ''
                                                        : formData.photo
                                                "
                                            />
                                        </div>
                                        <i
                                            v-else
                                            class="
                                                el-icon-plus
                                                avatar_uploader
                                                avatar-uploader-icon
                                            "
                                        ></i>
                                    </div>
                                </el-upload>
                            </el-form-item>
                        </el-col>

                        <el-col :span="11" :offset="1">
                            <el-form-item label="身份证号码：" prop="idCard">
                                <el-input
                                    :disabled="openData.title == '详情'"
                                    v-model="formData.idCard"
                                    @input="dateOfBirth"
                                    placeholder="请输入身份证号码"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="联系方式：" prop="phone">
                                <el-input
                                    :disabled="openData.title == '详情'"
                                    :maxlength="11"
                                    v-model.number="formData.phone"
                                    placeholder="请输入联系方式"
                                ></el-input>
                            </el-form-item>

                            <el-form-item label="民族：" prop="nation">
                                <el-select
                                    :disabled="openData.title == '详情'"
                                    v-model="formData.nation"
                                    placeholder="请选择"
                                >
                                    <el-option
                                        v-for="item in nation"
                                        :key="item"
                                        :label="item"
                                        :value="item"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item
                                label="与房主关系："
                                prop="relationship"
                            >
                                <el-select
                                    v-model="formData.relationship"
                                    :disabled="openData.title == '详情'"
                                    placeholder="请选择"
                                >
                                    <el-option
                                        v-for="item in relationList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item
                                label="工作单位或服务场所："
                                prop="workUnit"
                            >
                                <el-input
                                    :disabled="openData.title == '详情'"
                                    v-model.trim="formData.workUnit"
                                    placeholder="请输入"
                                ></el-input>
                            </el-form-item>
                            <el-form-item
                                label="视频："
                                prop="video"
                                align="left"
                            >
                                <div class="flashBox">
                                    <video
                                        class="flash"
                                        v-if="formData.video != ''"
                                        :src="formData.video"
                                        controls="controls"
                                    ></video>
                                    <el-upload
                                        :disabled="openData.title == '详情'"
                                        class="avatar-uploader"
                                        :action="videoUrl"
                                        :show-file-list="false"
                                        :on-success="handleVideoSuccess"
                                    >
                                        <i
                                            class="
                                                el-icon-plus
                                                avatar-uploader-icon
                                            "
                                        ></i>
                                    </el-upload>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-form-item label="备注：" prop="remark">
                        <el-input
                            v-model.trim="formData.remark"
                            :autosize="{ minRows: 2 }"
                            :disabled="openData.title == '详情'"
                            type="textarea"
                            placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="资源GIS定位：">
                        <el-button
                            type="success"
                            class="button"
                            size="medium"
                            @click="showMap"
                            style="margin-bottom: 25px"
                            >地图定位</el-button
                        >
                        <div v-show="isMaps == true">
                            <el-row>
                                <el-col :span="4">
                                    <el-form-item>
                                        <el-select
                                            v-model="formData.provinceId"
                                            placeholder="请选择省"
                                            @change="handleProvince"
                                            :disabled="
                                                normalInfo.orgLevel == 1 ||
                                                normalInfo.orgLevel == 2 ||
                                                normalInfo.orgLevel == 3 ||
                                                normalInfo.orgLevel == 4 ||
                                                normalInfo.orgLevel == 5 ||
                                                openData.title == '详情'
                                            "
                                            style="width: 100%"
                                            ref="selectShengChange"
                                        >
                                            <el-option
                                                v-for="(
                                                    item, index
                                                ) in provinceList"
                                                :key="index"
                                                :label="item.name"
                                                :value="item.adcode"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4" :offset="1">
                                    <el-select
                                        v-model="formData.cityId"
                                        placeholder="请选择市"
                                        :disabled="
                                            normalInfo.orgLevel == 2 ||
                                            normalInfo.orgLevel == 3 ||
                                            normalInfo.orgLevel == 4 ||
                                            normalInfo.orgLevel == 5 ||
                                            openData.title == '详情'
                                        "
                                        @change="handleCity"
                                        ref="selectShiChange"
                                        style="width: 100%"
                                    >
                                        <el-option
                                            v-for="(item, index) in cityList"
                                            :key="index"
                                            :label="item.name"
                                            :value="item.adcode"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="4" :offset="1">
                                    <el-select
                                        v-model="formData.zoneId"
                                        placeholder="请选择区"
                                        @change="handleArea"
                                        :disabled="
                                            normalInfo.orgLevel == 3 ||
                                            normalInfo.orgLevel == 4 ||
                                            normalInfo.orgLevel == 5 ||
                                            openData.title == '详情'
                                        "
                                        ref="selectQuChange"
                                        style="width: 100%"
                                    >
                                        <el-option
                                            v-for="(item, index) in areaList"
                                            :key="index"
                                            :label="item.name"
                                            :value="item.adcode"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="4" :offset="1">
                                    <el-select
                                        v-model="formData.streetId"
                                        placeholder="请选择街道"
                                        :disabled="
                                            normalInfo.orgLevel == 4 ||
                                            normalInfo.orgLevel == 5 ||
                                            openData.title == '详情'
                                        "
                                        @change="streetChange"
                                        ref="selectJiedaoChange"
                                    >
                                        <el-option
                                            v-for="(item, index) in streetList"
                                            :key="index"
                                            :label="item.addName"
                                            :value="item.addCode"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="4" :offset="1">
                                    <el-select
                                        v-model="formData.shequId"
                                        placeholder="请选择社区"
                                        :disabled="
                                            normalInfo.orgLevel == 5 ||
                                            openData.title == '详情'
                                        "
                                        ref="selectShequChange"
                                        @change="handleCommunityChange"
                                    >
                                        <el-option
                                            v-for="item in communityList"
                                            :key="item.id"
                                            :label="item.address"
                                            :value="item.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-col>
                            </el-row>
                            <input
                                v-model.trim="formData.address"
                                :disabled="openData.title == '详情'"
                                id="tipinput"
                                class="el-input__inner"
                                :class="
                                    openData.title == '详情' ? 'innerCur' : ''
                                "
                                @focus="getMap('tipinput')"
                                placeholder="请输入关键字"
                                autocomplete="off"
                            />
                            <div class="map_container">
                                <div
                                    class="map_right"
                                    id="container"
                                    style="width: 100%; height: 300px"
                                ></div>
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div
                slot="footer"
                class="dialog-footer dialog-footer-btn"
                v-if="openData.title != '详情'"
            >
                <el-button type="primary" @click="handleSubmit"
                    >确 定</el-button
                >
                <el-button @click="dialogVisibleClone">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import baseURL from "@/api/baseURL"
export default {
    props: ["openData"],
    data() {
        var chekPhone = (rule, value, callback) => {
            let validatePhone = /^1[3|4|5|6|7|8|9]\d{9}$/
            if (!validatePhone.test(value)) {
                return callback(new Error("手机号格式错误"))
            }
            callback()
        }
        return {
            videoUrl: "",
            videoFlag: false,
            videoUploadPercen: "",
            isShowUploadVideo: false,
            sexOptions: [
                { value: "1", label: "男" },
                { value: "2", label: "女" },
            ],
            // 民族
            nation: [
                "汉族",
                "蒙古族",
                "回族",
                "藏族",
                "维吾尔族",
                "苗族",
                "彝族",
                "壮族",
                "布依族",
                "朝鲜族",
                "满族",
                "侗族",
                "瑶族",
                "白族",
                "土家族",
                "哈尼族",
                "哈萨克族",
                "傣族",
                "黎族",
                "傈僳族",
                "佤族",
                "畲族",
                "高山族",
                "拉祜族",
                "水族",
                "东乡族",
                "纳西族",
                "景颇族",
                "柯尔克孜族",
                "土族",
                "达斡尔族",
                "仫佬族",
                "羌族",
                "布朗族",
                "撒拉族",
                "毛南族",
                "仡佬族",
                "锡伯族",
                "阿昌族",
                "普米族",
                "塔吉克族",
                "怒族",
                "乌孜别克族",
                "俄罗斯族",
                "鄂温克族",
                "德昂族",
                "保安族",
                "裕固族",
                "京族",
                "塔塔尔族",
                "独龙族",
                "鄂伦春族",
                "赫哲族",
                "门巴族",
                "珞巴族",
                "基诺族",
            ],
            educationList: [
                { value: "1", label: "小学" },
                { value: "2", label: "初中" },
                { value: "3", label: "高中" },
                { value: "4", label: "职校" },
                { value: "5", label: "专科" },
                { value: "6", label: "本科" },
                { value: "7", label: "硕士" },
                { value: "8", label: "博士" },
                { value: "9", label: "其他" },
            ],

            maritalList: [
                { value: "1", label: "未婚" },
                { value: "2", label: "已婚" },
                { value: "3", label: "离婚" },
                { value: "4", label: "丧偶" },
                { value: "5", label: "再婚" },
            ],
            relationList: [
                { value: "1", label: "本人" },
                { value: "2", label: "夫妻" },
                { value: "3", label: "父亲" },
                { value: "4", label: "母亲" },
                { value: "5", label: "岳父" },
                { value: "6", label: "岳母" },
                { value: "7", label: "长子" },
                { value: "8", label: "次子" },
                { value: "9", label: "长女" },
                { value: "10", label: "次女" },
                { value: "11", label: "其他" },
                { value: "12", label: "儿媳" },
                { value: "13", label: "孙子" },
                { value: "14", label: "孙女" },
                { value: "15", label: "女婿" },
                { value: "16", label: "租户" },
            ],

            baseURL: "",
            imageUrl: "",
            formData: {
                personName: "",
                idCard: "",
                phone: "",
                birthday: "",
                originPlace: "",
                origin: "",
                personnelType: "",
                populationType: "",
                sex: "",
                nation: "",
                education: "",
                maritalStatus: "",
                relationship: "",
                supervisorContact: "",
                detainUnit: "",
                correctType: "",
                caseCategory: "",
                charge: "",
                managerialClass: "",
                sentence: "",
                correctBdate: "",
                correctEdate: "",
                criminalType: "",
                receiveMode: "",
                fourHistory: "",
                recidivistFlag: "",
                threeStakeholders: "",
                correctTeamFlag: "",
                terminationType: "",
                whetherHosting: "",
                hostingWhy: "",
                examineStatus: "",
                correctStatus: "",
                whetherLeakagePipe: "",
                leakagePipeWhy: "",
                examineLeakagePipe: "",
                correctLeakagePipe: "",
                rewardsPunishment: "",
                executionPenaltyAlteration: "",
                recidivismFlag: "",
                rulingOrgans: "",
                workUnit: "",
                photo: "",
                video: "",
                remark: "",
                provinceId: "", //省
                cityId: "", //市
                zoneId: "", //区
                streetId: "", //街道
                shequId: "", //社区
                address: "",
                longitude: "",
                latitude: "",
            },
            orgList: [],
            provinceList: [], //省列表
            cityList: [], //市列表
            areaList: [], //区列表
            streetList: [], //街道列表
            communityList: [], //社区列表
            myMap: null,
            isMap: true,
            polygons: [],
            polygon: [],
            marker: null, //地图标记点
            recMap: null,
            recIsMap: true,
            recPolygons: [],
            recPolygon: [],
            showTap: false,
            recMarker: null, //地图标记点
            formDataRules: {
                personName: [
                    {
                        required: true,
                        message: "姓名不能为空",
                        trigger: "blur",
                    },
                ],
                idCard: [
                    {
                        required: true,
                        message: "身份证不能为空·",
                        trigger: "blur",
                    },
                    { validator: this.validID, trigger: "blur" },
                ],
                birthday: [
                    {
                        required: true,
                        message: "出生日期不能为空",
                        trigger: "blur",
                    },
                ],

                phone: [
                    //手机
                    {
                        required: true,
                        message: "联系方式不能为空",
                        trigger: "blur",
                    },
                    { validator: chekPhone, trigger: "blur" },
                ],

                originPlace: [
                    {
                        required: true,
                        message: "户籍地址不能为空",
                        trigger: "blur",
                    },
                ],

                sex: [
                    //手机
                    {
                        required: true,
                        message: "性别不能为空",
                        trigger: "blur",
                    },
                ],

                nation: [
                    {
                        required: true,
                        message: "民族不能为空",
                        trigger: "blur",
                    },
                ],
                education: [
                    {
                        required: true,
                        message: "文化程度不能为空",
                        trigger: "blur",
                    },
                ],
                maritalStatus: [
                    {
                        required: true,
                        message: "婚姻状态不能为空",
                        trigger: "blur",
                    },
                ],

                relationship: [
                    //手机
                    {
                        required: true,
                        message: "与户主关系不能为空",
                        trigger: "blur",
                    },
                ],

                workUnit: [
                    {
                        required: true,
                        message: "工作单位或服务场所不能为空",
                        trigger: "blur",
                    },
                ],
                // photo: [
                //     {
                //         required: true,
                //         message: "照片不能为空",
                //         trigger: "blur",
                //     },
                // ],
                // video: [
                //     {
                //         required: true,
                //         message: "视频不能为空",
                //         trigger: "blur",
                //     },
                // ],

                remark: [
                    //手机
                    {
                        required: true,
                        message: "备注不能为空",
                        trigger: "blur",
                    },
                ],
            },

            isMaps: false,
            normalInfo: {},
        }
    },
    created() {
        this.baseUrl =
            baseURL + "/ypt/controller/uploadController/info/uploadPhoto"
        this.videoUrl =
            baseURL + "/ypt/controller/uploadVotePic/info/uploadPartyVote"
        this.formData = {
            personName: "",
            idCard: "",
            phone: "",
            birthday: "",
            originPlace: "",
            origin: "",
            personnelType: "",
            populationType: "",
            correctTeamFlag: "",
            sex: "",
            nation: "",
            education: "",
            maritalStatus: "",
            relationship: "",
            supervisorContact: "",
            detainUnit: "",
            correctType: "",
            caseCategory: "",
            charge: "",
            managerialClass: "",
            sentence: "",
            correctBdate: "",
            correctEdate: "",
            criminalType: "",
            receiveMode: "",
            fourHistory: "",
            recidivistFlag: "",
            threeStakeholders: "",
            terminationType: "",
            whetherHosting: "",
            hostingWhy: "",
            examineStatus: "",
            correctStatus: "",
            whetherLeakagePipe: "",
            leakagePipeWhy: "",
            examineLeakagePipe: "",
            correctLeakagePipe: "",
            rewardsPunishment: "",
            executionPenaltyAlteration: "",
            recidivismFlag: "",
            rulingOrgans: "",
            workUnit: "",
            photo: "",
            video: "",
            remark: "",
            provinceId: "", //省
            cityId: "", //市
            zoneId: "", //区
            streetId: "", //街道
            shequId: "", //社区
            address: "",
            longitude: "",
            latitude: "",
        }
        this.getProvince()
        if (this.openData.title == "新增") {
        } else {
            this.dataInfos()
        }
        // setTimeout(async () => {
        //   await this.$nextTick(() => this.loadmap());
        // }, 200);
        this.getJoin()
    },
    methods: {
        //出生年月
        dateOfBirth(val) {
            var birthday = ""
            if (val != null && val != "") {
                if (val.length == 15) {
                    birthday = "19" + val.substr(6, 6)
                } else if (val.length == 18) {
                    birthday = val.substr(6, 8)
                }
                birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-")
            }
            this.formData.birthday = birthday
        },
        // 获取组织机构
        getJoin() {
            this.$http
                .request({
                    url: "/rbac/admin/org/info/findOrgById",
                    method: "POST",
                    data: { id: this.$store.state.info.orgId },
                })
                .then((res) => {
                    if (res.code == 200) {
                        // this.getProvince()
                        this.normalInfo = res.content
                        if (this.openData.title == "新增") {
                            this.changeFirst()
                        }
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        async changeFirst() {
            console.log(
                this.normalInfo,
                "机构信息 normalInfo.orgLevel",
                this.provinceList
            )
            let province = await this.getDistricts()
            this.provinceList = province.districtList
            if (this.normalInfo.provinceId == 0) {
                this.normalInfo.provinceId = ""
            } else {
                this.normalInfo.provinceId = String(this.normalInfo.provinceId)
                let cityList = await this.getDistricts(
                    this.normalInfo.provinceId
                )
                this.cityList = cityList.districtList
                console.log("城市", this.cityList)
            }
            if (this.normalInfo.cityId) {
                this.normalInfo.cityId = String(this.normalInfo.cityId)
                let areaList = await this.getDistricts(this.normalInfo.cityId)
                this.areaList = areaList.districtList
            } else {
                this.normalInfo.cityId = ""
            }

            if (this.normalInfo.areaId) {
                this.normalInfo.areaId = String(this.normalInfo.areaId)
                let streetList = await this.getStreetList(
                    this.normalInfo.areaId
                )
                this.streetList = streetList
            } else {
                this.normalInfo.areaId = ""
            }
            if (this.normalInfo.streetId) {
                this.normalInfo.streetId = String(this.normalInfo.streetId)
                let communityList = await this.getCommityList(
                    this.normalInfo.streetId
                )
                this.communityList = communityList
            } else {
                this.normalInfo.streetId = ""
            }
            if (
                this.normalInfo.orgLevel == 1 ||
                this.normalInfo.orgLevel == 0
            ) {
                this.provinceList.forEach((item) => {
                    if (item.adcode == this.normalInfo.provinceId) {
                        this.formData.latitude = item.center.lat
                        this.formData.longitude = item.center.lng
                    }
                })
            } else if (this.normalInfo.orgLevel == 2) {
                this.cityList.forEach((item) => {
                    if (item.adcode == this.normalInfo.cityId) {
                        this.formData.latitude = item.center.lat
                        this.formData.longitude = item.center.lng
                    }
                })
            } else if (this.normalInfo.orgLevel == 3) {
                this.areaList.forEach((item) => {
                    if (item.adcode == this.normalInfo.areaId) {
                        this.formData.latitude = item.center.lat
                        this.formData.longitude = item.center.lng
                    }
                })
            } else if (
                this.normalInfo.orgLevel == 4 ||
                this.normalInfo.orgLevel == 5
            ) {
                this.streetList.forEach((item, index) => {
                    if (item.addCode == this.normalInfo.streetId) {
                        this.formData.latitude = item.latitude
                        this.formData.longitude = item.longitude
                    }
                })
            }

            if (this.normalInfo.communityId) {
                this.normalInfo.communityId = Number(
                    this.normalInfo.communityId
                )
            } else {
                this.normalInfo.communityId = ""
            }
            this.formData.provinceId = this.normalInfo.provinceId
            this.formData.cityId = this.normalInfo.cityId
            this.formData.zoneId = this.normalInfo.areaId
            this.formData.streetId = this.normalInfo.streetId
            this.formData.shequId = this.normalInfo.communityId
            this.potintMap()
            this.$forceUpdate()
            // console.log(this.normalInfo, "机构信息",this.)
        },
        // 打点
        potintMap() {
            const self = this
            try {
                self.myMap.remove(self.marker)
            } catch (err) {
                console.log(err)
            }
            self.marker = new AMap.Marker({
                icon: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
                position: [
                    Number(self.formData.longitude),
                    Number(self.formData.latitude),
                ],
            })
            self.myMap.add(self.marker)
            self.myMap.setFitView()
        },
        // 地图打点
        getMap(input) {
            const self = this
            const autoOptions = {
                city: self.formData.zoneId,
                citylimit: true,
                input: input,
            }
            // alert(input)
            const auto = new AMap.Autocomplete(autoOptions)
            //构造地点查询类
            AMap.event.addListener(auto, "select", (e) => {
                self.formData.address = e.poi.name
                self.formData.longitude = e.poi.location.lng
                self.formData.latitude = e.poi.location.lat
                console.log(e.poi.location, "地址")
                self.potintMap()
            })
        },
        async streetChange(val) {
            this.formData.shequId = ""
            let communityList = await this.getCommityList(val)
            console.log(communityList, "社区列表")
            this.communityList = communityList
            this.joinAddress()
        },
        //街道地址列表
        getStreetList(val) {
            let self = this
            return new Promise((resolve, reject) => {
                self.$http
                    .request({
                        url: "/ypt/admin/addressYpe/info/findList",
                        method: "POST",
                        data: {
                            parentId: val,
                            pageNo: 1,
                            pageSize: -1,
                        },
                    })
                    .then((res) => {
                        if (res.code == 200) {
                            if (!res.content) {
                                resolve([])
                                return
                            }
                            this.streetList = res.content.list
                            resolve(res.content.list)
                        } else {
                            resolve([])
                        }
                    })
            }).catch((err) => {
                console.log(err)
            })
        },
        // 社区地址列表
        getCommityList(val) {
            let self = this
            return new Promise((resolve, reject) => {
                self.$http
                    .request({
                        url: "/ypt/admin/standardAddress/info/StandardAddressTree",
                        method: "POST",
                        data: {
                            jiedaoId: val,
                        },
                    })
                    .then((res) => {
                        if (res.code == 200) {
                            if (!res.content) {
                                resolve([])
                                return
                            }
                            resolve(res.content)
                        } else {
                            resolve([])
                        }
                    })
            }).catch((err) => {
                console.log(err)
            })
        },
        handleCommunityChange(val) {
            this.$nextTick(() => {
                this.$forceUpdate()
                this.joinAddress()
            })
        },
        //获取地址
        getDistricts(name = "中国", params = null) {
            let self = this
            return new Promise((resolve, reject) => {
                var opts = {
                    subdistrict: 1, //返回下一级行政区
                    extensions: "all",
                    showbiz: false, //最后一级返回街道信息
                }
                let district = new AMap.DistrictSearch(opts)
                let geocoder = new AMap.Geocoder({
                    city: "", //城市设为北京，默认：“全国”
                    radius: 1000, //范围，默认：500
                })
                try {
                    self.myMap.remove(self.marker)
                } catch (err) {
                    console.log(err)
                }

                self.marker = new AMap.Marker()
                district.search(name, (status, result) => {
                    if (status == "complete") {
                        resolve(result.districtList[0])
                        if (this.isMap) {
                            this.isMap = false
                            return
                        }
                        let bounds = result.districtList[0].boundaries
                        self.polygon = null
                    }
                })
            }).catch((err) => {
                console.log(err)
            })
        },
        async validID(rule, value, callback) {
            if (/(^\d{15}$)|(^\d{17}(\d|X|x)$)/.test(value)) {
                await this.go(value.length)
                callback()
            } else {
                callback(new Error("身份证号码不正确"))
            }
            //身份证城市
            var aCity = {
                11: "北京",
                12: "天津",
                13: "河北",
                14: "山西",
                15: "内蒙古",
                21: "辽宁",
                22: "吉林",
                23: "黑龙江",
                31: "上海",
                32: "江苏",
                33: "浙江",
                34: "安徽",
                35: "福建",
                36: "江西",
                37: "山东",
                41: "河南",
                42: "湖北",
                43: "湖南",
                44: "广东",
                45: "广西",
                46: "海南",
                50: "重庆",
                51: "四川",
                52: "贵州",
                53: "云南",
                54: "西藏",
                61: "陕西",
                62: "甘肃",
                63: "青海",
                64: "宁夏",
                65: "新疆",
                71: "台湾",
                81: "香港",
                82: "澳门",
                91: "国外",
            }
            if (!aCity[parseInt(value.substr(0, 2))]) {
                callback(new Error("你的身份证地区非法"))
            }
        },
        go(val) {
            let iden = this.formData.idCard
            let sex = null
            let birth = null
            let myDate = new Date()
            let month = myDate.getMonth() + 1
            let day = myDate.getDate()
            let age = 0

            if (val === 18) {
                age = myDate.getFullYear() - iden.substring(6, 10) - 1
                sex = iden.substring(16, 17)
                birth =
                    iden.substring(6, 10) +
                    "-" +
                    iden.substring(10, 12) +
                    "-" +
                    iden.substring(12, 14)
                if (
                    iden.substring(10, 12) < month ||
                    (iden.substring(10, 12) == month &&
                        iden.substring(12, 14) <= day)
                )
                    age++
            }
            if (val === 15) {
                age = myDate.getFullYear() - iden.substring(6, 8) - 1901
                sex = iden.substring(13, 14)
                birth =
                    "19" +
                    iden.substring(6, 8) +
                    "-" +
                    iden.substring(8, 10) +
                    "-" +
                    iden.substring(10, 12)
                if (
                    iden.substring(8, 10) < month ||
                    (iden.substring(8, 10) == month &&
                        iden.substring(10, 12) <= day)
                )
                    age++
            }

            if (sex % 2 === 0) sex = "2"
            else sex = "1" //1男2女
            this.formData.sex = sex
            this.formData.birthday = birth
            this.$forceUpdate()
        },
        // 地图显示
        showMap() {
            this.isMaps = !this.isMaps
            this.loadmap()
            setTimeout(() => {
                this.potintMap()
            }, 500)
        },
        // 详情页信息
        dataInfos() {
            const self = this
            let params = {
                id: self.openData.id,
            }
            this.$http
                .request({
                    url: "/ypt/admin/streamPeople/info/get",
                    method: "POST",
                    data: params,
                })
                .then(async (res) => {
                    if (res.code == 200) {
                        let jsonTemp = { ...res.content }
                        self.formData.id = jsonTemp.id
                        self.formData.personName = jsonTemp.personName
                        self.formData.idCard = jsonTemp.idCard
                        self.formData.phone = jsonTemp.phone
                        self.formData.birthday = jsonTemp.birthday
                        self.formData.originPlace = jsonTemp.originPlace
                        self.formData.origin = jsonTemp.origin
                        self.formData.personnelType = String(
                            jsonTemp.personnelType
                        )
                        self.formData.populationType = String(
                            jsonTemp.populationType
                        )
                        self.formData.sex = String(jsonTemp.sex)
                        self.formData.nation = jsonTemp.nation
                        self.formData.education = String(jsonTemp.education)
                        self.formData.maritalStatus = String(
                            jsonTemp.maritalStatus
                        )
                        self.formData.correctTeamFlag = String(
                            jsonTemp.correctTeamFlag
                        )

                        self.formData.relationship = String(
                            jsonTemp.relationship
                        )
                        self.formData.supervisorContact =
                            jsonTemp.supervisorContact
                        self.formData.detainUnit = jsonTemp.detainUnit
                        self.formData.correctType = String(jsonTemp.correctType)
                        self.formData.caseCategory = String(
                            jsonTemp.caseCategory
                        )
                        self.formData.charge = jsonTemp.charge
                        self.formData.managerialClass = String(
                            jsonTemp.managerialClass
                        )
                        self.formData.sentence = jsonTemp.sentence
                        self.formData.correctBdate = jsonTemp.correctBdate
                        self.formData.correctEdate = jsonTemp.correctEdate
                        self.formData.criminalType = jsonTemp.criminalType
                        self.formData.receiveMode = String(jsonTemp.receiveMode)
                        self.formData.fourHistory = String(jsonTemp.fourHistory)
                        self.formData.recidivistFlag = String(
                            jsonTemp.recidivistFlag
                        )
                        self.formData.threeStakeholders = String(
                            jsonTemp.threeStakeholders
                        )
                        self.formData.terminationType = String(
                            jsonTemp.terminationType
                        )
                        self.formData.whetherHosting = String(
                            jsonTemp.whetherHosting
                        )
                        self.formData.hostingWhy = jsonTemp.hostingWhy
                        self.formData.examineStatus = jsonTemp.examineStatus
                        self.formData.correctStatus = jsonTemp.correctStatus
                        self.formData.whetherLeakagePipe = String(
                            jsonTemp.whetherLeakagePipe
                        )
                        self.formData.leakagePipeWhy = jsonTemp.leakagePipeWhy
                        self.formData.examineLeakagePipe =
                            jsonTemp.examineLeakagePipe
                        self.formData.correctLeakagePipe =
                            jsonTemp.correctLeakagePipe
                        self.formData.rewardsPunishment =
                            jsonTemp.rewardsPunishment
                        self.formData.executionPenaltyAlteration =
                            jsonTemp.executionPenaltyAlteration
                        self.formData.recidivismFlag = String(
                            jsonTemp.recidivismFlag
                        )
                        self.formData.rulingOrgans = jsonTemp.rulingOrgans
                        self.formData.workUnit = jsonTemp.workUnit
                        self.formData.photo = jsonTemp.photo
                        self.formData.video = jsonTemp.video
                        self.formData.remark = jsonTemp.remark
                        self.formData.address = jsonTemp.address
                        self.formData.longitude = jsonTemp.longitude
                        self.formData.latitude = jsonTemp.latitude
                        self.formData.provinceId = String(jsonTemp.provinceId)
                        self.formData.cityId = String(jsonTemp.cityId)
                        self.formData.zoneId = String(jsonTemp.zoneId)
                        self.formData.streetId = String(jsonTemp.streetId)
                        self.formData.shequId = Number(jsonTemp.shequId)
                        if (!self.formData.provinceId) return
                        let city = await self.getDistrict(
                            self.formData.provinceId
                        )
                        self.cityList = city.districtList
                        if (!self.formData.cityId) return
                        let area = await self.getDistrict(self.formData.cityId)
                        self.areaList = area.districtList
                        if (!self.formData.zoneId) return
                        let street = await self.getStreetList(
                            self.formData.zoneId
                        )
                        self.streetList = street
                        if (!self.formData.streetId) return
                        let communityList = await self.getCommityList(
                            self.formData.streetId
                        )
                        self.communityList = communityList
                        if (self.formData.longitude && self.formData.latitude) {
                            this.loadmap()
                            setTimeout(() => {
                                this.potintMap()
                            }, 500)
                        }
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },

        //表格表单提交
        handleSubmit() {
            let self = this

            this.$refs.formData.validate((valid) => {
                if (valid) {
                    if (
                        this.openData.title == "新增" ||
                        this.openData.title == "编辑"
                    ) {
                        let url = ""

                        if (!self.formData.provinceId) {
                            self.$message.error("省级地址为必填项，请选择")
                            return
                        }
                        if (!self.formData.cityId) {
                            self.$message.error("市级地址为必填项，请选择")
                            return
                        }
                        if (!self.formData.zoneId) {
                            self.$message.error("区县级地址为必填项，请选择")
                            return
                        }
                        if (!self.formData.streetId) {
                            self.$message.error("街道地址为必填项，请选择")
                            return
                        }
                        if (
                            self.formData.shequId === "" ||
                            self.formData.shequId === null ||
                            self.formData.shequId === undefined
                        ) {
                            self.$message.error(
                                "社区为必填项，请选择,如无对应社区，请地址管理配置"
                            )
                            return
                        }
                        if (!self.formData.address) {
                            self.$message.error(
                                "详细信息为必填项，请在地图的边界内点击选择或手动输入"
                            )
                            return
                        }
                        delete this.formData.recTime
                        let data = { ...self.formData }
                        // data.serviceType = data.serviceType.toString()
                        // data.source = data.source.toString()
                        url = "/ypt/admin/streamPeople/info/save"
                        this.$http
                            .request({
                                url: url,
                                method: "POST",
                                data: {
                                    ...data,
                                },
                            })
                            .then((res) => {
                                if (res.code == 200) {
                                    this.$message.success(res.message)
                                    this.$emit("cancleService", true)
                                } else {
                                    this.$message.error(res.message)
                                }
                            })
                    }
                }
            })
        },
        // 上传图片前的判断
        beforeAvatarUpload(file) {
            const isJPG =
                file.type === "image/jpeg" || file.type === "image/png"
            const isLt2M = file.size / 1024 / 1024 < 5
            if (!isJPG) {
                this.$message.error("上传头像图片只能是 JPG 格式!")
                return isJPG
            }
            if (!isLt2M) {
                this.$message.error("上传头像图片大小不能超过 5MB!")
                return isLt2M
            }
        },
        //自定义图片上传
        handleAvatarSuccess(res, file, name) {
            this.$set(this.formData, "photo", res.content)
        },
        // handleAvatarSuccess1(res, file, name) {
        //   this.$set(this.formData, "video", res.content);
        //   if (this.formData.video.indexOf(".mp4") >= 0) {
        //     this.showTap = true;
        //   } else {
        //     this.$message({
        //       type: "warning",
        //       message: "请上传MP4格式",
        //     });
        //     this.showTap = false;
        //   }
        //   //console.log()
        // },
        beforeUploadVideo(file) {
            var fileSize = file.size / 1024 / 1024 < 50
            if (
                [
                    "video/mp4",
                    "video/ogg",
                    "video/flv",
                    "video/avi",
                    "video/wmv",
                    "video/rmvb",
                    "video/mov",
                ].indexOf(file.type) == -1
            ) {
                this.$message("请上传正确的视频格式")
                return false
            }
            if (!fileSize) {
                this.$message("视频大小不能超过50MB")
                return false
            }
            this.isShowUploadVideo = false
        },
        //进度条
        uploadVideoProcess(event, file, fileList) {
            this.videoFlag = true
            this.videoUploadPercent = file.percentage.toFixed(0) * 1
        },
        handleVideoSuccess(res, file) {
            //获取上传图片地址
            this.videoFlag = false
            this.videoUploadPercent = 0
            console.log(res)
            if (res.code == 200) {
                this.formData.video = res.content
            } else {
                this.$message.error("视频上传失败，请重新上传！")
            }
        },
        joinAddress(address = "") {
            let self = this
            self.$nextTick(() => {
                let shengName = this.$refs.selectShengChange.selectedLabel
                let shiName = this.$refs.selectShiChange.selectedLabel
                let quName = this.$refs.selectQuChange.selectedLabel
                let jiedaoName = this.$refs.selectJiedaoChange.selectedLabel
                let shequName = this.$refs.selectShequChange.selectedLabel
                if (!address) {
                    self.formData.address =
                        shengName + shiName + quName + jiedaoName + shequName
                }
                try {
                    self.myMap.remove(self.marker)
                } catch (err) {
                    console.log(err)
                }
                let geocoder = new AMap.Geocoder({ city: "" })
                self.marker = new AMap.Marker()
                geocoder.getLocation(
                    this.formData.address,
                    function (status, result) {
                        if (status === "complete" && result.geocodes.length) {
                            let lnglat = result.geocodes[0].location
                            self.formData.longitude = lnglat.lng
                            self.formData.latitude = lnglat.lat
                            self.marker.setPosition(lnglat)
                            self.myMap.add(self.marker)
                            self.myMap.setFitView(self.marker)
                        } else {
                            log.error("根据地址查询位置失败")
                        }
                    }
                )
            })
        },
        //获取地址
        getDistrict(name = "中国", params = null) {
            let self = this
            return new Promise((resolve, reject) => {
                var opts = {
                    subdistrict: 1, //返回下一级行政区
                    extensions: "all",
                    showbiz: false, //最后一级返回街道信息
                }
                let district = new AMap.DistrictSearch(opts)
                let geocoder = new AMap.Geocoder({
                    city: "", //城市设为北京，默认：“全国”
                    radius: 1000, //范围，默认：500
                })
                try {
                    self.myMap.remove(self.marker)
                } catch (err) {
                    console.log(err)
                }

                self.marker = new AMap.Marker()
                district.search(name, (status, result) => {
                    if (status == "complete") {
                        resolve(result.districtList[0])
                        if (this.isMap) {
                            this.isMap = false
                            return
                        }
                        let bounds = result.districtList[0].boundaries
                        self.polygon = null
                        if (bounds) {
                            try {
                                self.myMap.remove(self.polygons)
                            } catch (error) {
                                console.log("移除地图编辑出错了")
                            }
                            self.polygons = []
                            for (let i = 0, l = bounds.length; i < l; i++) {
                                self.polygon = new AMap.Polygon({
                                    map: self.myMap,
                                    strokeWeight: 1,
                                    strokeColor: "#0091ea",
                                    fillColor: "#80d8ff",
                                    fillOpacity: 0.4,
                                    path: bounds[i],
                                })
                                self.polygons.push(self.polygon)
                                if (!params) {
                                    self.polygon.on("click", function (e) {
                                        let lnglat = e.lnglat
                                        self.myMap.add(self.marker)
                                        self.marker.setPosition(lnglat)
                                        geocoder.getAddress(
                                            lnglat,
                                            function (status, result) {
                                                if (
                                                    status === "complete" &&
                                                    result.regeocode
                                                ) {
                                                    var address =
                                                        result.regeocode
                                                            .formattedAddress
                                                    self.formData.address =
                                                        address
                                                    self.formData.longitude =
                                                        lnglat.lng
                                                    self.formData.latitude =
                                                        lnglat.lat
                                                } else {
                                                    console.error(
                                                        "根据经纬度查询地址失败"
                                                    )
                                                }
                                            }
                                        )
                                    })
                                    self.myMap.add(self.polygons)
                                    self.myMap.setFitView() //地图自适应
                                } else {
                                    if (params.longitude && params.latitude) {
                                        self.myMap.add(self.marker)
                                        self.marker.setPosition([
                                            params.longitude,
                                            params.latitude,
                                        ])
                                        self.myMap.setFitView(self.marker)
                                        self.myMap.setZoom(11)
                                    }
                                }
                            }
                        }
                    }
                })
            }).catch((err) => {
                console.log(err)
            })
        },
        //获取省级
        async getProvince() {
            this.provinceList = []
            this.cityList = []
            this.areaList = []
            this.streetList = []
            let province = await this.getDistrict()
            this.provinceList = province.districtList
        },
        //  省级地址选择发生改变
        async handleProvince(val) {
            this.cityList = []
            this.areaList = []
            this.streetList = []
            this.communityList = []
            this.formData.cityId = ""
            this.formData.zoneId = ""
            this.formData.streetId = ""
            this.formData.shequId = ""
            this.formData.address = ""
            let city = await this.getDistrict(val)
            this.cityList = city.districtList
            this.joinAddress()
        },
        //市级地址发生改变
        async handleCity(val) {
            this.areaList = []
            this.streetList = []
            this.communityList = []
            this.formData.zoneId = ""
            this.formData.streetId = ""
            this.formData.shequId = ""
            this.formData.address = ""
            let area = await this.getDistrict(val)
            this.areaList = area.districtList
            this.joinAddress()
        },
        //县区级地址发生改变
        async handleArea(val) {
            this.streetList = []
            this.communityList = []
            this.formData.streetId = ""
            this.formData.shequId = ""
            this.formData.address = ""
            // val = val.replace(/.$/, "");
            let street = await this.getStreetList(val)
            this.streetList = street
            this.joinAddress()
        },

        //加载地图
        loadmap() {
            let self = this
            return new Promise((resolve, reject) => {
                self.myMap = new AMap.Map("container", {
                    resizeEnable: true,
                    zoom: 18,
                })
                resolve()
            })
        },
        // 关闭人员信息
        dialogVisibleClone() {
            // this.openData.state=false;
            this.$emit("cancleService", false)
        },
    },
}
</script>
<style lang="less" scoped>
.avatar {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    img {
        width: 200px;
        height: 200px;
        line-height: 200px;
        display: block;
    }
}
/deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    width: 200px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100%;
        height: 200px;
        line-height: 200px;
        text-align: center;
    }
}
.dialog-footer-btn {
    text-align: center;
}
/deep/.el-select {
    width: 100%;
}
/deep/.el-date-editor.el-input {
    width: 100%;
}
.flashBox {
    display: flex;
    justify-items: center;
    .flash {
        margin-right: 20px;
        width: 200px;
        height: 200px;
    }
}
</style>
